import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { useShellBreadcrumbs } from '@/app/layout/ShellContext';

/**
 * The breadcrumb trail above the content (§ Content-gebied), set by the
 * active page via `useBreadcrumbs`. Hidden below `md` and when the page set
 * no trail at all (e.g. it hasn't mounted yet).
 */
export function Breadcrumbs() {
  const crumbs = useShellBreadcrumbs();
  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className="text-ink mb-4 hidden text-sm md:block">
      <ol className="m-0 flex list-none flex-wrap items-center gap-1 p-0">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <Fragment key={`${crumb.label}-${index}`}>
              {index > 0 && (
                <li aria-hidden="true" className="text-ink">
                  /
                </li>
              )}
              <li>
                {crumb.to && !isLast ? (
                  <Link to={crumb.to} className="text-accent hover:underline">
                    {crumb.label}
                  </Link>
                ) : (
                  <span>{crumb.label}</span>
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
